module.exports = __webpack_public_path__ + "img/vertical_6_1_9016.24f85692.png";